import { NgModule } from "@angular/core";
import { TurnstileComponent } from "./components/turnstile/turnstile.component";

@NgModule({
  declarations: [TurnstileComponent],
  exports: [TurnstileComponent],
})
export class SharedModule {}
